import React from "react";
import { Link } from "react-router-dom";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="notfound-container">
      <div className="notfound-animation">
        <DotLottieReact
          src="https://lottie.host/19f96ae6-b7fe-4dda-a300-08506298cfac/TRuo4yQa3q.lottie"
          loop
          autoplay
        />
      </div>
      <h2>Oops! Page Not Found</h2>

      <p>
        The page you're looking for doesn't exist or may have been moved.
      </p>

      <Link to="/" className="home-btn">
        Back to Home
      </Link>
    </div>
  );
};

export default NotFound;